/**
 * The Dispatcher and Website tabs run on a local mock until their backend
 * exists (docs/dispatcher-chat-front.md). Development only - the flag is
 * set in `.env.development` and nowhere else.
 */
export const PUBLIC_CHAT_MOCK = process.env.NX_PUBLIC_CHAT_MOCK === 'true';
